import { InjectionToken } from '@angular/core';
export const AUTH_STRATEGY_TOKEN = /*#__PURE__*/new InjectionToken("AUTH_STRATEGY_TOKEN");
export function provideAuthStrategy(strategyDef) {
  return {
    provide: AUTH_STRATEGY_TOKEN,
    multi: true,
    useValue: strategyDef
  };
}
export const AUTH_STRATEGY_CONFIG_TOKEN = /*#__PURE__*/new InjectionToken("AUTH_STRATEGY_CONFIG_TOKEN");
export function provideAuthStrategyConfig(strategyName, config) {
  return {
    provide: AUTH_STRATEGY_CONFIG_TOKEN,
    multi: true,
    useValue: {
      name: strategyName,
      config: config || {}
    }
  };
}